import React, { useContext, useState, useEffect } from 'react';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick-theme.css';
import 'slick-carousel/slick/slick.css';
import { CommonContext } from '../../context';

const BannerSlider = () => {
    const { indexData, isMobile } = useContext(CommonContext);

    

    const settings = {
        dots: true,
        infinite: indexData?.banners?.length > 1,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: false,
        autoplaySpeed: 3000,
        arrows: true,
    };

    const handleImageClick = (link) => {
        if (link) {
            window.open(link, '_blank');
        }
    };

    return (
        <div className="banner-slider">
            <Slider {...settings}>
                {indexData && indexData?.banners?.length > 0 && indexData?.banners.map((banner) => (
                    <div 
                        key={banner?.id} 
                        onClick={() => handleImageClick(banner?.link)} 
                        style={{ cursor: 'pointer' }}
                    >
                        <img 
                            src={`${process.env.REACT_APP_BASE_URL}download/${isMobile ? banner?.mobile_banner : banner?.file}?pathName=banner`}
                            alt={banner?.title} 
                            className="banner-image img-fluid" 
                            style={{ cursor: 'pointer' }} 
                        />
                    </div>
                ))}
            </Slider>
        </div>
    );
};

export default BannerSlider;
